import classNames from 'classnames'
import React, { FC } from 'react'
import styles from './PercentChange.module.css'

const PercentChange: FC<{
	value: number | null | undefined
	className?: string
}> = (props) => {
	const { value: rawValue, className } = props
 const value = typeof rawValue === 'number' && Number.isFinite(rawValue) ? (Math.abs(rawValue) < 0.005 ? 0 : rawValue) : null

	return (
		<div
			className={classNames(
				{ [(props.className as any)]: !!className },
				{ [styles.negative]: (value ?? 0) < 0 },
				{ [styles.positive]: (value ?? 0) > 0 }
			)}
		>
			{(value ?? 0) > 0 && '+'}
			{value === null ? 'N/A' : `${value.toFixed(2)}%`}
		</div>
	)
}

export default PercentChange
